import { Star } from "lucide-react";
import { STATUS, TYPE, SENTIMENT, PRIORITY, COMPANY_STATUS, VISIBILITY, PUBLICATION } from "../../lib/labels";

const Pill = ({ cfg, testId }) =>
  cfg ? (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${cfg.cls}`}>
      {cfg.label}
    </span>
  ) : null;

export const StatusBadge = ({ value }) => <Pill cfg={STATUS[value]} testId="status-badge" />;
export const TypeBadge = ({ value }) => <Pill cfg={TYPE[value]} testId="type-badge" />;
export const SentimentBadge = ({ value }) => <Pill cfg={SENTIMENT[value]} testId="sentiment-badge" />;
export const PriorityBadge = ({ value }) => <Pill cfg={PRIORITY[value]} testId="priority-badge" />;
export const CompanyStatusBadge = ({ value }) => <Pill cfg={COMPANY_STATUS[value]} testId="company-status-badge" />;
export const VisibilityBadge = ({ value }) => <Pill cfg={VISIBILITY[value]} testId="visibility-badge" />;
export const PublicationBadge = ({ value }) => <Pill cfg={PUBLICATION[value]} testId="publication-badge" />;

export const Stars = ({ value, size = "h-3.5 w-3.5" }) => (
  <span className="inline-flex items-center gap-0.5" aria-label={`${value} sur 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className={`${size} ${i <= value ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
    ))}
  </span>
);
